import { render, staticRenderFns } from "./isupAccessControlList.vue?vue&type=template&id=ded8041c&scoped=true"
import script from "./isupAccessControlList.vue?vue&type=script&lang=js"
export * from "./isupAccessControlList.vue?vue&type=script&lang=js"
import style0 from "./isupAccessControlList.vue?vue&type=style&index=0&id=ded8041c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded8041c",
  null
  
)

export default component.exports